/* Gulf landing interactions. */
(()=>{'use strict';
const root=document.querySelector('.pgj-gulf');
if(!root||root.dataset.initialized)return;
root.dataset.initialized='true';
const $=s=>root.querySelector(s), $$=s=>[...root.querySelectorAll(s)];
const current=$('#gulf-current'), gallery=$('.gulf-thumbs');
if(current&&gallery){
  gallery.querySelectorAll('[data-gulf-thumb]').forEach((button)=>button.addEventListener('click',()=>{
    const image=button.querySelector('img');
    if(!image)return;
    current.src=image.src;
    current.alt='TAG Heuer Formula 1 Gulf product photo';
    gallery.querySelectorAll('button').forEach((item)=>item.setAttribute('aria-pressed',String(item===button)));
  }));
}
const zoomButton=$('.gulf-gallery-main');
if(zoomButton&&current){
  zoomButton.addEventListener('click',()=>{
    const dialog=document.createElement('dialog');
    dialog.className='gulf-zoom';
    dialog.innerHTML='<button class="gulf-close" type="button" aria-label="Tutup foto">&times;</button><img alt="">';
    dialog.querySelector('img').src=current.src;
    dialog.querySelector('img').alt=current.alt;
    document.body.append(dialog);
    dialog.showModal();
    const close=()=>{dialog.close();dialog.remove();};
    dialog.querySelector('button').addEventListener('click',close);
    dialog.addEventListener('click',(event)=>{if(event.target===dialog)close();});
  });
}
if('IntersectionObserver'in window){
  if(!matchMedia('(prefers-reduced-motion: reduce)').matches){
    const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('gulf-pending');reveal.unobserve(entry.target);}}),{threshold:.08});
    $$('.gulf-reveal').forEach(item=>{item.classList.add('gulf-pending');reveal.observe(item);});
  }
  const sticky=$('[data-gulf-sticky]');
  if(sticky){let hero=true,buy=false,ending=false;const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.target.matches('.gulf-hero'))hero=entry.isIntersecting;else if(entry.target.matches('.gulf-buy'))buy=entry.isIntersecting;else ending=entry.isIntersecting;sticky.hidden=hero||buy||ending;}));['.gulf-hero','.gulf-buy','.gulf-final'].forEach(selector=>{const target=$(selector);if(target)observer.observe(target);});}
}
})();
